import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=3b3661f4"
import script from "./FeedbackList.vue?vue&type=script&lang=ts"
export * from "./FeedbackList.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=3b3661f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports